import { z } from 'zod'
import { productSchema } from '@/schemas/product'

export const smartPickProductsSchema = z.object({
  totalCount: z.number(),
  results: z.array(productSchema),
})

export type SmartPickProducts = z.infer<typeof smartPickProductsSchema>
